require('./RASustainabilityDisclaimer.scss');

//@vendors
const React = require('react');

//@utilities
const { FormattedText } = require('core/i18n').i18n;

class RASustainabilityDisclaimer extends React.Component {
    render() {
        return (
            <div className="ra-sustainability-disclaimer__container">
                <div className="ra-sustainability-disclaimer__title">
                    <i className="ra-sustainability-disclaimer-icon icon" />
                    <h4>
                        <FormattedText value="raSustainabilityQuestion-disclaimerText_A" />
                    </h4>
                    <ul className="ra-sustainability-disclaimer__list">
                        <li>
                            <FormattedText value="raSustainabilityQuestion-disclaimerText_B" />
                        </li>
                        <li>
                            <FormattedText value="raSustainabilityQuestion-disclaimerText_C" />
                        </li>
                        <li>
                            <FormattedText value="raSustainabilityQuestion-disclaimerText_D" />
                        </li>
                    </ul>
                </div>
            </div>
        );
    }
}

module.exports = RASustainabilityDisclaimer;
